module.exports = __webpack_public_path__ + "static/media/205-Pflegemassnahmen_ID_17.4e9667f0.mp3";